import { gql } from '@apollo/client';

export const RESET_ONBOARDING = gql`
  mutation ResetOnboarding {
    resetOnboarding {
      id
      isNew
      currentStep
      completedSteps
    }
  }
`;
